import "../../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import s from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/date-picker/src/DatePicker.js";
import { defineComponent as c, h as u } from "../../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import r from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import f from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/checkbox/src/Checkbox.js";
import b from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/checkbox/src/CheckboxGroup.js";
import p from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/Radio.js";
import v from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/RadioGroup.js";
import y from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
const D = c({
  name: "InputTypeItem",
  props: {
    modelValue: {
      type: String,
      required: !1,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    item: {
      type: Object,
      default: () => ({ inputType: "", options: [] })
    }
  },
  emits: ["update:modelValue", "changeHandleInput"],
  setup(e, { emit: i }) {
    const m = (t) => {
      if (!t)
        return null;
      if (typeof t == "string") {
        const n = new Date(t);
        return isNaN(n.getTime()) ? null : n.getTime();
      }
      const a = new Date(t);
      return isNaN(a.getTime()) ? null : a.getTime();
    }, d = (t) => {
      i("changeHandleInput", t);
    }, o = () => {
      var n;
      const { inputType: t, options: a } = e.item;
      if (!t)
        return u(r, {
          style: { width: "100px" },
          disabled: e.disabled,
          value: e.modelValue,
          "on-update:value": d
        });
      switch (t) {
        case "DATE":
          return u(s, {
            type: "date",
            clearable: !1,
            disabled: e.disabled,
            value: m(e.modelValue),
            format: "yyyy-MM-dd",
            onUpdateFormattedValue: (l) => {
              d(l);
            }
          });
        case "SELECT":
          return u(y, {
            filterable: !0,
            value: e.modelValue,
            options: a == null ? void 0 : a.map((l) => ({
              label: l,
              value: l
            })),
            "on-update:value": d
          });
        case "RADIO":
          return u(
            v,
            {
              disabled: e.disabled,
              value: e.modelValue,
              "on-update:value": d,
              class: "radio-class"
            },
            a == null ? void 0 : a.map(
              (l) => u(p, {
                label: l,
                value: l
              })
            )
          );
        case "CHECKBOX":
          return u(
            b,
            {
              disabled: e.disabled,
              value: ((n = e.modelValue) == null ? void 0 : n.split("，")) || [],
              "on-update:value": (l) => d(l.join("，")),
              class: "checkbox-class"
            },
            a == null ? void 0 : a.map(
              (l) => u(f, {
                label: l,
                value: l
              })
            )
          );
        default:
          return u(r, {
            style: { width: "100px" },
            disabled: e.disabled,
            value: e.modelValue,
            "on-update:value": d
          });
      }
    };
    return () => o();
  }
});
export {
  D as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/inputTypeItem/index.vue2.js
// module id = 1259
// module chunks = 67